$(function () {

    $('.link-mr-login').on('click', function (event) {
        $('.ibis-login, .freja-login').collapse('hide');
        $('.mr-login').collapse('show');
    });

    $('.link-freja-login').on('click', function (event) {
        $('.ibis-login, .mr-login').collapse('hide');
        $('.freja-login').collapse('show');
    });

    $('.link-ibis-login').on('click', function (event) {
        $('.mr-login, .freja-login').collapse('hide');
        $('.ibis-login').collapse('show');
    });
});